import { HideRuleGrammar } from "./grammars/hide.rule.grammar.type";
import { GrammarHelper } from "./grammar.helper";
import { ExpertChipExpression } from "@nrwl/query-emitter";
declare var require: any;
const hideGrammarParser = require("./grammars/hide.rule.grammar");

export class HideRuleExpressionParser {

  public parseIntoTokens(expression:string): ExpertChipExpression[] {
    try {
      const kTree = hideGrammarParser.parse(expression, { types: HideRuleGrammar });
      const explanation: ExpertChipExpression[] = kTree.explain();
      if (Array.isArray(explanation)) {
        explanation.forEach(token => {
          GrammarHelper.normalizeExpertChipExpression(token);
        });
      }
      else {
        GrammarHelper.normalizeExpertChipExpression(explanation);
      }
      return explanation;
    } catch (error) {
      return null;
    }
  }
}
